<div class="content1">
  <h2 *ngIf="selectedTab">Selected Tab: {{ selectedTab.label }} ({{ selectedTab.value }})</h2>
  <p *ngIf="!selectedTab">Please select a tab from the sidebar.</p>
</div>

<div class="content1" *ngIf="selectedTab">
 
  <app-crews *ngIf="selectedTab.value =='crews'"></app-crews>
</div>
